import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppInitializerService } from './app-initializer.service';
import { AppMaterialModule } from 'app/modules/shared/vendor/app-material.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './modules/shared/shared.module';
import { CommonPipesModule } from './shared/pipes/common-pipes.module';
// import { CookiePolicyComponent } from 'modules/onecart/components/cookie-policy/cookie-policy.component';
import { ToastrModule } from 'ngx-toastr';
import { AppInterceptor } from './app.interceptor';
import { Unavailable503Component } from 'modules/shared/components/unavailable503/unavailable503.component';
import { environment } from 'environments/environment';
import { RouterModule } from '@angular/router';
import { WebSocketService } from './modules/admin/shared/services/websocket.service';

declare var $: any;

@NgModule({
  declarations: [AppComponent, Unavailable503Component],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    SharedModule,
    HttpClientModule,
    AppMaterialModule,
    CommonPipesModule,
    NgIdleKeepaliveModule.forRoot(),
    ToastrModule.forRoot({ preventDuplicates: true, autoDismiss: true, maxOpened: 1, timeOut: 4000, positionClass: 'toast-top-right' }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: AppInitializerProviderFactory,
      deps: [AppInitializerService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true,
    },
    WebSocketService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function AppInitializerProviderFactory(provider: AppInitializerService) {
  return () =>
    provider.load().then((data) => {
      if (data) {
        console.log('success');
      } else {
        console.log('failure');
      }
    });
}
